import TreasureBonusComponent from 'components/treasure-bonus-component';
import PickRequest from 'slotworks/model/gameplay/requests/pick-request';
import CommsManager from 'slotworks/server/comms-manager';
import State from 'slotworks/state-machine/states/state';
import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import { GameType } from 'names/do-names';
import Components from 'slotworks/components/components';
import SmartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import GameInit from './game-init';
import doSettingsModel from 'model/do-settings-model';
import betModel from 'slotworks/model/bets/bet-model';
import BetMenuMediator from 'slotworks/mediators/bet-menu-mediator';

export default class TreasureBonus extends State {
    private bonusComponent: TreasureBonusComponent;

    public onEnter() {
        GameInit.gameType = GameType.bonusGame;
        this.bonusComponent = new TreasureBonusComponent();
        this.bonusComponent.onClicked.add(this.onItemClick);
        Components.betBar.setEnabled(false);        
        bonusBuyComponent.hideWithoutAnimation();
        SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
        this.bonusComponent.start().then(() => this.complete());
    }

    public complete() {
        this.bonusComponent.end();
        if(doSettingsModel.isCurrentBonusBuyOut) {
            const betMenuMediator = new BetMenuMediator();
            betMenuMediator.start().execute();
            betMenuMediator.end();
        }
        doSettingsModel.isCurrentBonusBuyOut = false;
        bonusBuyComponent.show();
        super.complete();
    }

    private onItemClick = (index: number) => {
        const pickRequest = new PickRequest();
        pickRequest.pick = index - 1;
        this.bonusComponent.setAllButtonActive(false);

        CommsManager.request(pickRequest).then(() => {
            this.bonusComponent.populateResultsAndShow(index);
        });
    };
}



// WEBPACK FOOTER //
// ./src/states/treasure-bonus.ts